import React from "react";
import { IconBoxDevice, IconBoxInfo } from "../../components/Icons/Icons";
import styles from "./PageProjectDetail.module.css";

export const FoundEvolutionTab = () => {
  const yearOptions = ["2025-1", "2024-1", "2024-2", "2023-1", "2023-2"];

  // 🔥 Data quemada
  const mockFund = {
    evolution_description:
      "Este fideicomiso ha mostrado un crecimiento estable en los últimos años, con una TIR promedio del 12% y pagos de rendimientos semestrales. Se enfoca en proyectos inmobiliarios con diversificación regional y un enfoque sostenible.",
    accountability: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    tax_certificate: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
    operator_report: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
  };

  return (
    <div
      className="page-security-head"
      style={{
        padding: "5px 10px",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div className="flex-column w-50">
        <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center" }}>
          <IconBoxDevice
            colorIcon="#1b4ec1"
            height="15px"
            width="15px"
          />
          <span style={{ marginLeft: "10px" }}>
            Evolución del vehículo de inversión
          </span>
        </div>
        <p
          style={{ textAlign: "start" }}
          className={`mr-5 ${styles.infoTecBoxText}`}
        >
          {mockFund.evolution_description}
        </p>
      </div>

      <div style={{ textAlign: "justify" }} className="tab-container w-50">
        <div className="page-security-head" style={{ padding: "5px 0px 0px" }}>
          <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center" }}>
            <IconBoxInfo
              colorIcon={"#1b4ec1"}
              height={"20px"}
              width={"25px"}
            />
            <span style={{ marginLeft: "10px" }}>Documentos relevantes</span>
          </div>
        </div>

        {[
          {
            title: "Rendición de cuentas",
            href: mockFund.accountability,
            download: "RendicionDeCuentas.pdf",
            icon: "bi bi-clipboard-check",
          },
          {
            title: "Certificados tributarios",
            href: mockFund.tax_certificate,
            download: "CertificadoTributario.pdf",
            icon: "bi bi-file-earmark-check",
          },
          {
            title: "Informe del operador",
            href: mockFund.operator_report,
            download: "InformeOperador.pdf",
            icon: "bi bi-bar-chart-line",
          },
        ].map((doc, index) => (
          <div key={index} className="infoTec" style={{ marginTop: "10px" }}>
            <div className="infoTecBox d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="icon-box" style={{ color: "#B9DE2C" }}>
                  <i className={doc.icon}></i>
                </div>
                <div style={{ marginLeft: "10px" }}>
                  <div className="infoTecBoxTitle">{doc.title}</div>
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "#5B6576" }}
                  >
                    <select className={styles.selectYear}>
                      {yearOptions.map((year, idx) => (
                        <option key={idx} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                    <i className="bi bi-paperclip"></i>
                    <a
                      href={doc.href}
                      download={doc.download}
                      className="infoTecBoxTitle"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Ver documento
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
